import React          from 'react';
import withNavigation from '../apps/common/navigation/hoc/withNavigation';
import E404Layout     from './E404Layout';

const E404Container = () => <E404Layout />

export default withNavigation(E404Container);